import anna from './anna';
import {BrandConfig} from './types';

export const currentBrand: BrandConfig = anna;

export default currentBrand;
